<template>

    <!-- navbar -->
    <nav class="navbar navbar-expand-lg navbar-light sticky-top">

        <div class="collapse navbar-collapse" id="navbarSupportedContent">

            <ul class="navbar-nav my-2 my-lg-0 ml-auto">
                <router-link to="/stringer/upload" tag="button" class="btn btn-success mt-sm-1" v-if="userInfo.role !== 'media_purchaser' && userInfo.role !== 'media_producer'"><i class="fa fa-plus pr-2"></i> Upload Video</router-link>

                <li class="nav-item dropdown dropdown-notifications mr-4 ml-4">

                    <a class="nav-link dropdown-toggle nav-user" href="#" id="notifications" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-bell-o" v-if="!hasNotifications"></i>
                        <i :data-count="notificationsCount" class="fa fa-bell notification-icon" v-if="hasNotifications"></i>
                    </a>

                    <div class="dropdown-menu dropdown-menu-right dropdown-top-65" aria-labelledby="notifications" v-on:click.stop>
                        <div class="dropdown-toolbar">
                            <h3 class="dropdown-toolbar-title">Notifications ({{ notificationsCount }})</h3>
                        </div>

                        <notifications></notifications>

                        <div class="dropdown-footer text-center" v-if="hasNotifications">
                            <a href="#" v-on:click="readNotifications">Clear All</a> <span class="ml-3 mr-3"></span> <router-link to="/stringer/upload">View All</router-link>
                        </div>

                    </div>

                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle nav-user" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-cloak>
                        Hello, {{ userInfo.name }}
                    </a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-top-65" aria-labelledby="navbarDropdown">
						<router-link to="/stringer/settings" class="dropdown-item" v-if="userInfo.role !== 'media_purchaser'">Settings</router-link>
						
						<div class="dropdown-divider" v-if="userInfo.role == 'administrator' || userInfo.role == 'superadministrator'"></div>
						<router-link to="/stringer/dashboard" class="dropdown-item" v-if="userInfo.role == 'administrator' || userInfo.role == 'superadministrator'">Stringer Portal</router-link>
						<router-link to="/media/latest" class="dropdown-item" v-if="userInfo.role == 'administrator' || userInfo.role == 'superadministrator'">Media Portal</router-link>
						<router-link to="/admin/dashboard" class="dropdown-item" v-if="userInfo.role == 'administrator' || userInfo.role == 'superadministrator'">Administrator Portal</router-link>

                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#" v-on:click="performLogout()">Logout</a>
                    </div>
                </li>
            </ul>
        </div>

    </nav>

</template>

<script>

    import { mapActions, mapGetters } from 'vuex';
    import Notifications from '../partials/Notifications'

	export default {
		name: 'Navbar',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App',
				searchFocused: false,
			}
		},
		components: {
            'notifications': Notifications,
		},
		computed: {
			...mapGetters([
                'hasNotifications',
                'userInfo',
                'notificationsCount'
            ]),
        },
        methods: {
            ...mapActions([
				'logout',
				'readNotifications'
            ]),
            performLogout() {
                this.logout().then(() => {
                    this.$router.replace('/login');
                })
            },
        }
		
	}
</script>

<style scoped>

	.sidebar {
		height: 100vh;
		background-color: #0055A3;
		color: #fff;
	}

	.sidebar_head {
		height: 80px;
		width: 100%;
		background-color: #004F96;
	}
	

	/* if page is active */
	/* .nav .nav-item {
		border-left: 2px solid #fff;
	} */

	.nav .nav-item a {
		color: #fff;
	}


	.navbar {
		height: 80px;
		background-color: #fff;
	}

	.dropdown-toggle::after {
		vertical-align: 0.1em;
	}

	.nav-user {
		font-size: 18px;
    	color: #0055A3;
		font-weight: 600;
	}


	/* fixed and fluid only on sm and up */
	@media (min-width: 768px) {

		.fixed {
			flex: 0 0 200px;
			min-height: 100vh;
			min-width: 350px
		}

		.col .fluid {
			min-height: 100vh;
		}

		.flex-grow {
			flex:1;
		}

	}


	#navSearch {
		background-color: transparent;
		border: 0px;
		position: relative;
		font-size: 16px;
		font-weight: 600;
	}

	.input-group-addon {
		background-color: transparent;
		border: 0px;
		position: relative;
		font-size: 16px;
		font-weight: 600;
	}

	.user-panel {
		background-color: #F6F7F8;
		padding: 0px;
	}



	/* fixed and fluid only on sm and up */
	@media (min-width: 768px) {

		.fixed {
			flex: 0 0 200px;
			min-height: 100vh;
			min-width: 350px
		}

		.col .fluid {
			min-height: 100vh;
		}

		.flex-grow {
			flex:1;
		}

	}

	/* overrides */

	.profile-details-btn {
		position: absolute;
		right: 20px;
		top: 20px;
		height: 36px;
	}

	.profile-details-btn span {
		font-size: 12px;
		vertical-align: middle;
		display: block;
	}

	.name {
		font-size: 24px;
		font-weight: 600;
	}

	.title {
		font-size: 20px;
		font-weight: 600;
	}

	.city {
		font-size: 18px;
		font-weight: 600;
	}

	.tab-content {
		background-color: #fff;
	}

	.nav-tabs > .nav-item > .nav-link {
		padding: 10px 40px 10px 40px;
	}

	.nav-tabs > .nav-item > a {
		font-size: 16px;
		color: #959CA3;
		font-weight: 600;
	}

	.nav-tabs > .nav-item > a.active {
		color: #0055A3;
	}

	.nav-tabs .nav-link.active {
		border: none;
	}

	.nav-tabs {
		border-bottom:none;
	}

	.nav-tabs .nav-link {
		border: none;
	}

	.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
		border: none;
	}

	.outline {
		border: 1px solid #E9ECEF;
	}

	.btn-outline-primary-custom {
		color: #0055A3;
		background-color: transparent;
		background-image: none;
		border-color: #E7EBEE;
	}

	.fw-300 {
		font-weight: 300;
	}

	.fw-400 {
		font-weight: 300;
	}

	.fw-500 {
		font-weight: 300;
	}

	.fw-600 {
		font-weight: 600;
	}

	.sidebar .nav-item, .sub-menu {
		border-bottom: 1px solid rgba(255, 255, 255, 0.05);
		border-left: none;
		transition: border-left 200ms;
	}

	.sidebar .nav-item.active {
		border-left: 2px solid #fff;;
	}

	.sidebar ul :not(collapsed) .arrow:before,
	.sidebar li :not(collapsed) .arrow:before {
		font-family: FontAwesome;
		content: "\f078";
		display: inline-block;
		vertical-align: middle;
		float: right;
	}

	.sidebar .nav-item:hover {
		border-left: 4px solid #fff;
		transition: border-left 200ms;
	}

	.sub-menu {
		list-style: none;
	}

	.sub-menu li {
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.sub-menu li a {
		color: #fff;
	}

	.sub-menu li a:hover {
		text-decoration: none;
	}

	footer {
		background-color: #EFF1F3;
		text-align: center;
		color: #868e96 !important;
    }
    
    .btn-success.active {
        background-color: #82C843;
		border: 0;
	}
	
	.notification-icon:after {
		position: absolute;
		content: attr(data-count);
		margin-left: -7.8775px;
		margin-top: -7.8775px;
		padding: 0 4px;
		min-width: 17px;
		height: 17px;
		line-height: 17px;
		background: red;
		border-radius: 10px;
		color: #fff;
		text-align: center;
		vertical-align: middle;
		font-size: 10.004px;
		font-weight: 600;
		font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	}

	.tt-dropdown-menu {
		margin: 21px 0 0;
		width: 100%;
		padding: 0;
		background-color: #fff;
		border-radius: 0 0 2px 2px;
	}

</style>
